import * as React from 'react';
import { createPortal } from 'react-dom';

interface ReactPortalProps {
  children: React.ReactNode;
  wrapperId: string;
}

const ReactPortal = ({ children, wrapperId = 'react-portal' }: ReactPortalProps) => {
  const [wrapperEl, setWrapperEl] = React.useState<HTMLElement | null>(null);

  const creatWrapperAndAppendToBody = (idOfWrapper: string) => {
    const wrapperElement = document.createElement('div');
    wrapperElement.setAttribute('id', idOfWrapper);
    document.body.appendChild(wrapperElement);
    return wrapperElement;
  };

  React.useLayoutEffect(() => {
    let element = document.getElementById(wrapperId);
    let systemCreated = false;
    if (!element) {
      systemCreated = true;
      element = creatWrapperAndAppendToBody(wrapperId);
    }
    setWrapperEl(element);
    return () => {
      if (element) {
        if (systemCreated && element.parentNode) {
          element.parentNode.removeChild(element);
        }
      }
    };
  }, [wrapperId]);

  if (wrapperEl == null) return null;

  return createPortal(children, wrapperEl);
};

export default ReactPortal;
